import { resolveImagePath } from '@/utils/imageResolver';

export function PartnerLogos() {
  const continentalLogo = resolveImagePath('/uploads/6/0/7/8/60782893/cmi.png');
  const cirrusLycomingLogo = resolveImagePath('/uploads/6/0/7/8/60782893/1464022079.png');

  return (
    <section className="py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-items-center">
          {/* Continental Motors Logo */}
          <div className="flex justify-center">
            <a href="#" className="inline-block">
              <img
                src={continentalLogo}
                alt="Continental Motors, Inc."
                className="h-16 w-auto object-contain hover:opacity-80 transition-opacity duration-200"
              />
            </a>
          </div>
          
          {/* Cirrus Aircraft & Lycoming Logos */}
          <div className="flex justify-center">
            <a href="#" className="inline-block">
              <img
                src={cirrusLycomingLogo}
                alt="Cirrus Aircraft and Lycoming"
                className="h-16 w-auto object-contain hover:opacity-80 transition-opacity duration-200"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}